var map = {
	"./001.png": "2p2c",
	"./002.png": "gH8/",
	"./003.png": "bTF/",
	"./004.png": "tIat",
	"./005.png": "vmkA",
	"./006.png": "j8NU",
	"./007.png": "aOC/",
	"./008.png": "LC89",
	"./009.png": "Z01d",
	"./010.png": "FMFe",
	"./011.png": "Ec9/",
	"./012.png": "BRO4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "60qi";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projectLogo ^\.\/.*\.png$
// module id = 60qi
// module chunks = 0